var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"comments-link"},[_c(!_vm.navigationDisabled ? 'router-link' : 'span',{tag:"Component",attrs:{"to":_vm.viewCommentsRoute}},[_c('span',{class:_vm.commentsClasses},[_vm._v(" "+_vm._s(_vm.commentsCountMessage)+" ")]),(_vm.hasUnreadCommentsMentions)?_c('AxUnreadMentionsIndicator'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }